import React from 'react';
import ClassesList from './ClassesList';
import NoClassesToDisplay from './NoClassesToDisplay';
import Compare from './Compare';

class ResultPanel extends React.Component {

  render() {
    switch (this.props.status) {
      case "NO_CLASSES_FOUND":
        return (
          <NoClassesToDisplay />
        );
      case "CLASSES_FOUND":
        return (<div disabled={this.props.status === "LOADING"}>
          <ClassesList classes={this.props.classes} searchFilter={this.props.searchFilter} addCompare={this.props.addCompare} compares={this.props.compares} downrangeLocations={this.props.downrangeLocations} />
        </div>
        );
      case "SHOW_COMPARES":
        return (
          <Compare compares={this.props.compares} removeCompare={this.props.removeCompare} downrangeLocations={this.props.downrangeLocations} />
        );
      default:
        return (
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        )
    }
  }
}

export default ResultPanel;